import { render, staticRenderFns } from "./materialTemplate.vue?vue&type=template&id=2dfd38b7&scoped=true"
import script from "./materialTemplate.vue?vue&type=script&lang=js"
export * from "./materialTemplate.vue?vue&type=script&lang=js"
import style0 from "./materialTemplate.vue?vue&type=style&index=0&id=2dfd38b7&prod&lang=less&scoped=true"
import style1 from "./materialTemplate.vue?vue&type=style&index=1&id=2dfd38b7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfd38b7",
  null
  
)

export default component.exports